module.exports = __webpack_public_path__ + "img/momo_index_button_2.205b4a4c.png";